export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

export const ROUTES = {
  // Marketing site (public, served at the root)
  LANDING: '/',
  GUIDE_WHO_DOES_WHAT: '/guides/who-does-what',
  GUIDE_LEASE_OR_BUY: '/guides/lease-or-buy',

  // Application (mounted under /app)
  APP_HOME: '/app',
  LOGIN: '/app/signin',
  SIGNUP: '/app/signup',
  FORGOT_PASSWORD: '/app/forgot-password',
  SIGNUP_HORSE_OWNER: '/app/signup/horse-owner',
  SIGNUP_RIDER: '/app/signup/rider',
  HORSE_OWNER_HOME: '/app/horse-owner',
  HORSE_OWNER_PROFILE: '/app/horse-owner/profile',
  HORSE_OWNER_MY_HORSES: '/app/horse-owner/my-horses',
  HORSE_OWNER_ADD_HORSE: '/app/horse-owner/add-a-horse',
  HORSE_OWNER_HORSE_DETAIL: '/app/horse-owner/my-horses/:horseId',
  RIDER_WELCOME: '/app/signup/rider/welcome',
  HORSE_RIDER_HOME: '/app/horse-rider',
  RIDER_BROWSE_HORSES: '/app/horse-rider/browse-horses',
  RIDER_HORSE_DETAIL: '/app/horse-rider/browse-horses/:horseId',
  RIDER_PROFILES: '/app/horse-rider/rider-profiles',
  RIDER_NEW_PROFILE: '/app/horse-rider/rider-profiles/new',
  RIDER_EDIT_PROFILE: '/app/horse-rider/rider-profiles/:profileId/edit',
  RIDER_MY_EOIS: '/app/horse-rider/my-eois',
  BOOKING_REQUESTS: '/app/booking-requests',
  DASHBOARD: '/app/dashboard',
  ADMIN_APPROVAL: '/app/admin/approval',
} as const;

export const ADMIN_EMAIL = 'admin@gmail.com';

export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  USER: 'user',
} as const;
